import React from 'react';

import styles from '../../assets/styles/CustomRadio.module.scss';

const CustomRadio = ({ name, value, id, onChange, customClass = '' }) => {
  const radioStyle = `${styles.CustomRadio} ${customClass}`;
  return (
    <input
      type={'radio'}
      name={name}
      value={value}
      id={id}
      onChange={onChange}
      className={radioStyle}
    />
  );
};

export default CustomRadio;
